import { Modal, ModalHeader, ModalFooter, ModalContent, Notification, BulletList, Button, ExternalLink, Text } from "@netapp/bxp-design-system-react"
import { useSelector, useDispatch } from "react-redux";
import typography from "@netapp/bxp-design-system-react/styles/typography.module.scss";
import externals from "utils/externals";
import styles from "./ManualWeakConnectorUpgradeDialog.module.scss"
import { useTranslation } from "react-i18next";
import { currentConnector as i18nNamespace } from "../../../i18n/namespace";

const GcpDialog = ({close}) => {
    const { t } = useTranslation(i18nNamespace);
    return <Modal>
        <ModalHeader>
            {t("machine_type_change_required")}
        </ModalHeader>
        <ModalContent>
            <Notification type="info" messageStyle={{fontSize: 13}}>
                {t("connector_machine_type_requirements")}
            </Notification>
            <Text bold>
                {t("machine_type_change_intro")}
            </Text>

            <BulletList liClassName={styles.li}>
                <>{t("goto_gcp_console_select")}</>
                <>{t("gcp_path")}<span className={typography.b}>{t("machine_type")}</span>{t("save_and_start")}
                    <p style={{marginTop: 16}}><span className={typography.b}>{t("note")}</span>{t("gcp_change_note")}</p>
                </>
                <>{t("after_the_instance_up")}<ExternalLink variant="text" trackCategory="CurrentConnector" trackLabel="Cloud Manager SaaS" href={externals.saasFrontend}>{externals.saasFrontend}</ExternalLink>
                </>
            </BulletList>
        </ModalContent>
        <ModalFooter>
            <ExternalLink
                trackCategory="CurrentConnector"
                trackLabel="Go To Console - Manual Upgrade"
                href="https://console.cloud.google.com/compute/instances"
                newTab
            >{t("goto_gcp_console")}</ExternalLink>
            <Button color="secondary" onClick={close}>{t("not_now")}</Button>
        </ModalFooter>
    </Modal>
}

const AzureDialog = ({close}) => {
    const { t } = useTranslation(i18nNamespace);
    return <Modal>
        <ModalHeader>
            {t("vm_type_change_required")}
        </ModalHeader>
        <ModalContent>
            <Notification type="info" messageStyle={{fontSize: 13}}>
                {t("connector_vm_type_requirements")}
            </Notification>
            <Text bold>
                {t("vm_type_change_intro")}
            </Text>
            <BulletList liClassName={styles.li}>
                <>{t("goto_azure_portal_and_select")}</>
                <>{t("select_size_choose_the_d8s_v3")}<span className={typography.b}>D8s v3</span>{t("vm_type_and_then_click_resize")}
                    <p style={{marginTop: 16}}><span className={typography.b}>{("note")}</span>{t("azure_chnage_note")}</p>
                </>
                <>{t("after_the_instance_up")}<ExternalLink trackCategory="CurrentConnector" trackLabel="Cloud Manager SaaS" href={externals.saasFrontend}>{externals.saasFrontend}</ExternalLink>
                </>
            </BulletList>
        </ModalContent>
        <ModalFooter>
            <ExternalLink
                trackCategory="CurrentConnector"
                trackLabel="Go To Console - Manual Upgrade"
                href="https://portal.azure.com/"
                newTab
            >{t("go_to_the_azure_console")}</ExternalLink>
            <Button color="secondary" onClick={close}>{t("not_now")}</Button>
        </ModalFooter>
    </Modal>
}

const AwsDialog = ({close}) => {
    const { t } = useTranslation(i18nNamespace);
    return <Modal>
        <ModalHeader>
            {t("instance_type_change_is_required")}
        </ModalHeader>
        <ModalContent>
            <Notification type="info" messageStyle={{fontSize: 13}}>
                {t("connector_instance_requirements")}
            </Notification>
            <Text bold>
                {t("instance_change_intro")}
            </Text>
            <BulletList liClassName={styles.li}>
                <>{t("goto_aws_console")}</>
                <>{t("aws_path")}<span className={typography.b}>t3.2xlarge</span>
                    <Text style={{marginTop: 16}}><span className={typography.b}>{t("note")}</span>{t("aws_change_note")}</Text>
                </>
                <>{t("after_the_instance_up")}<ExternalLink trackCategory="CurrentConnector" trackLabel="Cloud Manager SaaS" href={externals.saasFrontend}>{externals.saasFrontend}</ExternalLink>
                </>
            </BulletList>
        </ModalContent>
        <ModalFooter>
            <ExternalLink
                trackCategory="CurrentConnector"
                trackLabel="Go To Console - Manual Upgrade"
                href="https://console.aws.amazon.com/ec2/v2/home"
                newTab
            >{t("go_to_the_aws_console")}</ExternalLink>
            <Button onClick={close}>{t("not_now")}</Button>
        </ModalFooter>
    </Modal>
}
const OnPremDialog = ({close}) => {
    const { t } = useTranslation(i18nNamespace);
    return <Modal>
        <ModalHeader>
            {t("instance_change_is_required")}
        </ModalHeader>
        <ModalContent>
            <Notification type="info" messageStyle={{fontSize: 13}}>
                {t("onprem_instance_requirements")}
            </Notification>
        </ModalContent>
        <ModalFooter>
            <Button onClick={close}>{t("close")}</Button>
        </ModalFooter>
    </Modal>
}

const Dialog = () => {
    const agent = useSelector(state => state.tenancy.selectedAgent)
    const _provider = useSelector(state => state.currentConnector.weakConnectorDialogProvider)
    const dispatch = useDispatch();
    const provider = _provider || agent.provider;

    const close = () => {
        dispatch({
            type: "CURRENT-CONNECTOR:CLOSE-WEAK-CONNECTOR-DIALOG"
        })
    }

    if(provider === "gcp") {
        return <GcpDialog close={close}/>
    } else if (provider === "azure") {
        return <AzureDialog close={close}/>
    } else if (provider === "aws") {
        return <AwsDialog close={close}/>
    } else {
        return <OnPremDialog close={close}/>
    }
}

export default Dialog;
